import Button from '@jetbrains/ring-ui/components/button/button'
import Dialog from '@jetbrains/ring-ui/components/dialog/dialog'
import {Content, Header} from '@jetbrains/ring-ui/components/island/island'
import React from 'react'

import {useBoolean} from '../../../../../hooks/useSlice'
import CertificateUploadForm from '../../CertificateInstallationForm/CertificateUploadForm/CertificateUploadForm'

function UploadCertificateButton() {
  const [show, showDialog, hideDialog] = useBoolean(false)

  return (
    <>
      <Button onClick={showDialog}>{'Upload new...'}</Button>
      <Dialog
        show={show}
        onCloseAttempt={hideDialog}
        onEscPress={hideDialog}
        showCloseButton
        trapFocus
      >
        <Header>{'Upload new certificate'}</Header>
        <Content>
          <CertificateUploadForm />
        </Content>
      </Dialog>
    </>
  )
}

export default React.memo(UploadCertificateButton)
